module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/example-4-a607b0f9c80564357cb925cee149e6ed.png";